<template>
  <KioskLayout :isCentered="true">

    <template #KioskLayout__right>
      <UploadedPhotosSidebar/>
    </template>

    <template #KioskLayout__bottom>
      <KioskStepProgressIndicator :index="0"/>
    </template>

    <div class="PhotoPromptFromPhone">
      <h1 class="kiosk-title">{{ $t('PhotoPromptFromPhone.title') }}</h1>

      <div class="PhotoPromptFromPhone__caption kiosk-caption kiosk-pre-line">
        {{ $t('PhotoPromptFromPhone.caption') }}
      </div>

      <div class="PhotoPromptFromPhone__actions">
        <RouterLink class="kiosk-button-inline" data-testid="phone-prompt-upload" :to="router.getLinkToStep('photo-from-phone')">
          {{ $t('PhotoPromptFromPhone.buttonUpload') }}
        </RouterLink>
        <button class="kiosk-button kiosk-button--arrow-right" data-testid="phone-prompt-skip" @click="onSkipUploadClick">
          {{ $t('PhotoPromptFromPhone.buttonSkip') }}
        </button>
      </div>
    </div>
  </KioskLayout>
</template>


<script>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
import KioskStepProgressIndicator from '@/app/layouts/kiosk/KioskStepProgressIndicator.vue';
import { router } from '@/app/router';
import { store } from '@/app/store';
import UploadedPhotosSidebar from '@/components/UploadedPhotosSidebar.vue';
import { sentryService } from '@/services/telemetry/sentry';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
import { warnMessageOf } from '@/shared/utils/track-telemetry';
import { faceDetection } from '../../services/FaceDetection';

export default {
  components: {
    UploadedPhotosSidebar,
    KioskStepProgressIndicator,
    KioskLayout,
  },
  data() {
    return {
      router,
      _isUnmounted: false,
    };
  },
  async mounted() {
    exposeToGlobalScope(this);
    this._isUnmounted = false;

    try {
      sentryService.addBreadcrumb('navigation', 'PhotoPromptFromPhone mounted');
      sentryService.setCurrentStep('photo_prompt_from_phone');
    } catch (_e) {
      // Sentry call failed silently
    }

    // Check if mobile upload is disabled for this kiosk
    // Only hide if explicitly true, otherwise show (respect DB setting)
    const isMobileUploadHidden = store.kiosk?.hide_mobile_upload === true;
    if (isMobileUploadHidden) {
      sentryService.addBreadcrumb(
        'navigation',
        'PhotoPromptFromPhone: mobile upload disabled, skipping to faces'
      );
      router.redirectToStep('faces');
      return;
    }
  },
  beforeUnmount() {
    this._isUnmounted = true;
  },
  methods: {
    onSkipUploadClick() {
      sentryService.addBreadcrumb(
        'user_action',
        'PhotoPromptFromPhone: skip upload clicked'
      );
      faceDetection
        .skipMobileUploads()
        .then(() => {
          if (this._isUnmounted) return;
          router.redirectToStep(store.photoUploadNextStep);
        })
        .catch((e) =>
          warnMessageOf('[PhotoPromptFromPhone] skipMobileUploads failed:', e)
        );
    },
  },
};
</script>


<style scoped lang="scss">
  .PhotoPromptFromPhone {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .PhotoPromptFromPhone__caption {
    max-width: 25rem;
    margin: 2.2rem auto 2.6rem auto;
    text-align: center;
  }

  .PhotoPromptFromPhone__actions {
    display: flex;
    flex-direction: var(--photo-prompt-actions-direction, row);
    align-items: var(--photo-prompt-actions-align-items, normal);

    *:first-child {
      margin-right: var(--photo-prompt-first-action-margin-right, 2.5rem);
      margin-bottom: var(--photo-prompt-first-action-margin-bottom, 0);
    }
  }
</style>
